<template>
  <DossierOperationalBase :config="config" />
</template>

<script>
import DossierOperationalBase from "../dossier/operational/DossierOperationalBase.vue";

export default {
  name: "DossierWorkSchedule",

  components: { DossierOperationalBase },

  data() {
    return {
      config: {
        // ── Identidade ─────────────────────────────────────────────────────
        moduleKey: "work-schedule",
        title: "Escalas de Trabalho",
        subtitle:
          "Registro e controle das escalas de trabalho por turno, função ou setor",
        icon: "fas fa-calendar-alt",
        itemName: "escala",
        addLabel: "Nova escala",
        namePlaceholder: "Ex: Escala noturna – Enfermagem",
        explainer:
          "Registre as escalas de trabalho da instituição. Cada escala deve " +
          "conter o período de vigência, o tipo (turno, função ou setor), o " +
          "profissional responsável e o arquivo PDF com a escala detalhada. " +
          "O sistema controla automaticamente quais escalas estão vigentes, " +
          "futuras ou encerradas.",

        // ── Tipos disponíveis ──────────────────────────────────────────────
        typeOptions: [
          "Turno matutino",
          "Turno vespertino",
          "Turno noturno",
          "Plantão 12×36",
          "Plantão 24h",
          "Escala semanal",
          "Escala mensal",
          "Enfermagem",
          "Cuidadores",
          "Administrativo",
          "Cozinha",
          "Limpeza",
          "Segurança",
          "Outros",
        ],

        // ── Permissões ─────────────────────────────────────────────────────
        writePermission: "dossier_write",
        readPermission: "dossier_read",

        // ── Endpoints ──────────────────────────────────────────────────────
        listEndpoint: "/rest-home/dossier/work-schedule",
        saveEndpoint: "/rest-home/dossier/work-schedule",
        uploadEndpoint: "/rest-home/dossier/work-schedule/upload",
        deleteEndpoint: "/rest-home/dossier/work-schedule",
      },
    };
  },
};
</script>